<script setup lang="ts">
interface Props {
  text?: string;
  icon?: string;
  ariaLabel: string;
}

defineProps<Props>();

defineEmits<{
  click: [MouseEvent];
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'p-4 rounded flex gap-1 outline-2 border-none',
      'hover:outline hover:outline-2 hover:outline-neutral700',
      'focus-visible-base',
    ]"
    :ariaLabel="ariaLabel"
    @click="(event) => $emit('click', event)"
  >
    <slot>
      <i v-if="icon" :class="icon"></i>
      <span v-if="text">{{ text }}</span>
    </slot>
  </button>
</template>
